import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Outlet, Link, Route } from "react-router-dom";
import { createStore } from "redux";
import rootReducer from "./reducer";

import NoPage from "./pages/NoPage/NoPage";

import { BrowserRouter, Routes } from "react-router-dom";
import App from "./App";
const store = createStore(rootReducer);

const Layout = () => {
  return (
    <>
      <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/blogs">Blogs</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </nav>

      <Outlet />
    </>
  );
};

render(
  <App>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}></Route>
          {/* <Route path="/*" element={<NoPage />} /> */}
        </Routes>
      </BrowserRouter>
    </Provider>
  </App>,
  document.getElementById("root"),
);
